import { render } from "./ServerPager.vue?vue&type=template&id=182fd448"
import script from "./ServerPager.vue?vue&type=script&lang=js"
export * from "./ServerPager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Agent/ServerPager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "182fd448"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('182fd448', __exports__)) {
    api.reload('182fd448', __exports__)
  }
  
  module.hot.accept("./ServerPager.vue?vue&type=template&id=182fd448", () => {
    api.rerender('182fd448', render)
  })

}


export default __exports__